import React from "react";
import { RankingComponentProps } from "types/ranking";
import { getAvatarImage } from "utils/avatars";

export function ListRanking({
  players,
  title = "Ranking Completo",
  className = "",
}: RankingComponentProps) {

  return (
    <div
      className={`flex flex-col h-full bg-slate-900/80 backdrop-blur-md rounded-2xl border border-white/10 ${className}`}
    >
      {/* Header com título */}
      <div className="p-6 pb-4">
        {title && (
          <h2 className="text-white text-2xl font-bold">{title}</h2>
        )}
      </div>

      {/* Lista de ranking */}
      <div className="flex-1 overflow-y-auto px-6 pb-6 scrollbar-thin">
        {players.length > 0 ? (
          <div className="space-y-3">
            {players.map((player) => {
              const avatarImage = getAvatarImage(
                player.fotoDePerfil || player.avatar
              );

              return (
                <div
                  key={player.id}
                  className="flex items-center gap-4 bg-white/5 hover:bg-white/10 rounded-xl p-4 transition-all border border-white/5"
                >
                  {/* Posição */}
                  <div className="flex-shrink-0 w-8 text-center">
                    <span className="text-2xl font-bold text-white">
                      {player.position}
                    </span>
                  </div>

                  {/* Avatar */}
                  <div className="flex-shrink-0">
                    {avatarImage ? (
                      <img
                        src={avatarImage}
                        alt={player.name}
                        className="w-12 h-12 rounded-full object-cover border-2 border-purple-500"
                      />
                    ) : (
                      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center">
                        <span className="text-white text-lg font-bold">
                          {player.name.charAt(0).toUpperCase()}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Informações do Jogador */}
                  <div className="flex-1 min-w-0">
                    <div className="text-white font-semibold text-base truncate">
                      {player.name}
                    </div>
                    <div className="text-white/60 text-sm truncate">
                      {player.teamName && player.location
                        ? `${player.teamName} • ${player.location}`
                        : player.teamName || player.location || ""}
                    </div>
                  </div>

                  {/* Pontos */}
                  <div className="flex-shrink-0 text-right">
                    <div className="text-white font-bold text-lg">
                      {player.points?.toLocaleString("pt-BR") || 0}
                    </div>
                    <div className="text-white/60 text-xs">pontos</div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex items-center justify-center h-full text-white/60">
            Nenhum dado de ranking disponível
          </div>
        )}
      </div>
    </div>
  );
}
